















import { dateLongFormat } from '@/filters/dateFormat'
import { SalesOrgImportDto } from '@/services/connecteur'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  filters: {
    dateLongFormat
  }
})
export default class SalesOrgImportItem extends Vue {
  @Prop({ required: true })
  public importStatus!: SalesOrgImportDto

  public get color() {
    return this.importStatus.isSuccess ? 'green' : 'red'
  }

  public get icon() {
    return this.importStatus.isSuccess ? 'check-circle' : 'times-circle'
  }
}
